import type { Coding, Practitioner, Reference } from '@medplum/fhirtypes'
import { SIGNATURE_VOIDED_TAG_SYSTEM } from '#src/codeSystems.ts'
import { Tag } from '#src/decorators.ts'
import {
  ExtendedProvenance,
  ProvenanceParticipantType,
} from '#src/models/provenance.ts'
import { getReferenceString } from '#src/references.ts'
import type { QueryTypes } from '#src/search.ts'

export class Signature extends ExtendedProvenance {
  static queryByTarget(
    target: string | string[],
    options: { includeVoided?: boolean } = {
      includeVoided: true,
    }
  ): QueryTypes {
    return {
      target,
      ...(!options.includeVoided && {
        '_tag:not': `${SIGNATURE_VOIDED_TAG_SYSTEM}|`,
      }),
      // TODO: add once we backfill
      // 'agent-type':
      //   PROVENANCE_PARTICIPANT_TYPE_MAP[ProvenanceParticipantType.SIGNER],
      _sort: '-_lastUpdated',
      _count: '1000',
    }
  }

  static queryByTargetAndWho(
    target: Reference,
    who: Reference<Practitioner>
  ): QueryTypes {
    return {
      ...this.queryByTarget(getReferenceString(target)),
      agent: who,
    }
  }

  constructor({
    target,
    who,
    recorded,
  }: {
    target: Reference
    who: Reference<Practitioner>
    recorded?: string
  }) {
    super({ target, who, type: ProvenanceParticipantType.SIGNER, recorded })
  }

  @Tag({
    system: SIGNATURE_VOIDED_TAG_SYSTEM,
  })
  _voided?: Coding

  get voided(): boolean {
    return this._voided?.code === 'true'
  }

  set voided(value: boolean) {
    this._voided = value ? { code: 'true' } : undefined
  }
}
